import { db } from "../Config";

/*
** Menus
*/

export const fetchMenus = async () => {
  let menus = {};
  await db
    .collection("configuraciones_generales").doc("menu")
    .get()
    .then((doc) => {
      menus = doc.data();
      console.log('menus', menus);
    })
    .catch((err) => {
      throw new Error(err);
    });
  return menus.items;
};
